import React, { Fragment, useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
// import { BrowserWidgetsCardData } from '../Data/Widgets';
import { P } from "../../AbstractElements";
import { getStatusBadge } from "../../Utils/otherFunctions";
import { getStatusData } from "../../Constant/StatusData";
import { RefreshCcw } from "react-feather";

const StatusWidget = ({ statusList, type, pending, refreshList }) => {
  const [countStatus, setCountStatus] = useState({});
  const [statusType, setStatusType] = useState();

  useEffect(() => {
    if (statusList.length) {
      countStatuses(statusList);
    }
  }, [statusList]);

  const countStatuses = (data) => {
    const statusCounts = {};

    if (type === "Transaksi") {
      setStatusType("transaksi");
      data.forEach((item) => {
        if (!statusCounts[item.id_status_transaksi]) {
          statusCounts[item.id_status_transaksi] = 0;
        }

        statusCounts[item.id_status_transaksi] += 1;
      });
    } else if (type === "Uang Muka Kegiatan") {
      setStatusType("umk");
      data.forEach((item) => {
        if (!statusCounts[item.id_status_umk]) {
          statusCounts[item.id_status_umk] = 0;
        }

        statusCounts[item.id_status_umk] += 1;
      });
    } else if (type === "Uang Muka Operasional") {
      setStatusType("umo");
      data.forEach((item) => {
        if (!statusCounts[item.id_status_umo]) {
          statusCounts[item.id_status_umo] = 0;
        }

        statusCounts[item.id_status_umo] += 1;
      });
    } else if (type === "Realokasi") {
      setStatusType("realokasi");
      data.forEach((item) => {
        if (!statusCounts[item.id_status_realokasi]) {
          statusCounts[item.id_status_realokasi] = 0;
        }

        statusCounts[item.id_status_realokasi] += 1;
      });
    }

    setCountStatus(statusCounts);
  };

  return (
    <Fragment>
      <Row>
        {Object.entries(countStatus).map(([status, count]) => {
          console.log(parseInt(status));
          console.log(type);
          const statusData = getStatusData(parseInt(status), statusType);
          console.log(statusData);

          return (
            <Col key={status}>
              <div className={"d-flex flex-column align-items-center"}>
                {getStatusBadge(statusData)}

                <P>
                  <span className="counter">
                    {count}
                    {/* <CountUp end={count} /> */}
                  </span>
                </P>
              </div>
            </Col>
          );
        })}
        {/* <Col className="px-3">
          <Button
            color={"light"}
            className={"d-flex p-2 rounded-circle align-items-center"}
            style={{ height: 35, width: 35 }}
            disabled={pending}
            onClick={refreshList}
          >
            {pending ? <Spinner size={"sm"} /> : <RefreshCcw className="p-0" />}
          </Button>
        </Col> */}
      </Row>
    </Fragment>
  );
};

export default StatusWidget;
